const themeStore = {
    alert: { title: '', subtitle: '', active: false, type: 'error' },
    loading: false,
    pageTitle: '',
    sideBar: false
}

export default themeStore